export default __webpack_public_path__ + "static/media/2.c59b06e6.svg";